import React from 'react';
import { Alert, Col, Descriptions, Row, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const Features = () => {
    return (
        <Row className="p-3">
            <Col className="mb-3">
                <Title level={4}>Overall Length</Title>
                <Paragraph>
                    The Minimum Overall Length is <strong>0.100"</strong>. The Maximum Overall Length is{' '}
                    <strong>3.000"</strong>. Due to the manufacturing process of QuickTurn Parts, the Overall Length
                    cannot be more than 3x the Outer Diameter.
                </Paragraph>

                <Alert
                    type="info"
                    className="mb-3"
                    showIcon={true}
                    message={
                        <>
                            If Thru-Hole is enabled, the Maximum Overall Length is determined by the Thru-Hole Diameter.
                            Please see the table below for details.
                        </>
                    }
                />
                <Descriptions bordered layout="horizontal" size="small" column={1} style={{ maxWidth: '360px' }}>
                    <Descriptions.Item label={<strong>Thru-Hole Diameter</strong>}>
                        <strong>Max Overall Length</strong>
                    </Descriptions.Item>
                    <Descriptions.Item label={`0.250" - 0.374"`}>1.000"</Descriptions.Item>
                    <Descriptions.Item label={`0.375" - 0.499"`}>1.500"</Descriptions.Item>
                    <Descriptions.Item label={`0.500" - 0.624"`}>2.000"</Descriptions.Item>
                    <Descriptions.Item label={`0.625" or larger`}>3.000"</Descriptions.Item>
                </Descriptions>
            </Col>
            <Col className="mb-3">
                <Title level={4}>Outer Diameter</Title>
                <Paragraph>
                    The Minimum Outer Diameter is <strong>0.250"</strong>, or <strong>0.350"</strong> if Thru-Hole is
                    enabled. The Maximum Outer Diameter is <strong>2.000"</strong>, or <strong>1.900"</strong> if Flange
                    is enabled.
                </Paragraph>
            </Col>
            <Col className="mb-3">
                <Title level={4}>Flange</Title>
                <Paragraph>
                    The Minimum Flange Diameter is <strong>0.100"</strong> larger than the current Outer Diameter. The
                    Maximum Flange Diameter is <strong>2.000"</strong>.
                </Paragraph>
            </Col>
            <Col className="mb-3">
                <Title level={4}>Thru-Hole</Title>
                <Paragraph>
                    The Minimum Thru-Hole Diameter is <strong>0.250"</strong>. The Maximum Thru-Hole Diameter is{' '}
                    <strong>0.100"</strong> small than the current Outer Diameter, or <strong>0.100"</strong> smaller
                    than the current Counterbore, if enabled.
                </Paragraph>
            </Col>
            <Col className="mb-3">
                <Title level={4}>Counterbore</Title>
                <Paragraph>
                    The Minimum Counterbore Diameter is <strong>0.100"</strong> larger than the current Thru-Hole
                    Diameter. The Maximum Counterbore Diameter is <strong>0.100"</strong> small than the current Outer
                    Diameter.
                </Paragraph>
                <Paragraph>
                    The Minimum Counterbore Depth is <strong>0.050"</strong>. The Maximum Counterbore Depth is{' '}
                    <strong>0.100"</strong> less than the current Overall Length.
                </Paragraph>
            </Col>
            <Col className="mb-3">
                <Title level={4}>Countersink</Title>
                <Paragraph>
                    The Minimum Countersink Angle is <strong>60 deg</strong>. The Maximum Countersink Angle is{' '}
                    <strong>120 deg</strong>.
                </Paragraph>
                <Paragraph>
                    The Maximum Countersink Depth is limited by the Overall Length, Outer Diameter, and the Thru-Hole
                    Diameter.
                </Paragraph>
            </Col>
            <Col className="mb-3">
                <Title level={4}>Chamfer</Title>
                <Paragraph>
                    The Minimum Chamfer Size is <strong>0.005"</strong>. The Maximum Chamfer Size is{' '}
                    <strong>0.015"</strong>.
                </Paragraph>
            </Col>
            <Col className="mb-0">
                <Title level={4}>Tolerances</Title>
                <Paragraph>Tolerances for all dimensions are +/- 0.005".</Paragraph>
            </Col>
        </Row>
    );
};

export default Features;
